import React from 'react';
import { View, Text, Pressable } from 'react-native';
import { Upload, Database, Mic } from 'lucide-react-native';
import { useThemeColors } from '@/lib/useThemeColors';

interface ScoreCTAEmptyStateProps {
  onUploadDeck?: () => void;
  onConnectDataRoom?: () => void;
  onScoringInterview?: () => void;
}

interface CTACardProps {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  highlightBg?: string;
  disabled?: boolean;
  comingSoon?: boolean;
  onPress?: () => void;
  colors: any;
}

function CTACard({
  icon,
  title,
  subtitle,
  highlightBg,
  disabled = false,
  comingSoon = false,
  onPress,
  colors,
}: CTACardProps) {
  const bg = highlightBg ?? colors.surface.secondary;

  return (
    <View
      style={{
        height: 56,
        borderRadius: 10,
        backgroundColor: bg,
        borderWidth: 1,
        borderColor: colors.border.light,
        overflow: 'hidden',
        opacity: disabled ? 0.5 : 1,
        marginBottom: 8,
      }}
    >
      <Pressable
        style={{ flex: 1, flexDirection: 'row', alignItems: 'center', paddingHorizontal: 12 }}
        onPress={onPress}
        disabled={disabled}
      >
        <View
          style={{
            width: 32,
            height: 32,
            borderRadius: 8,
            backgroundColor: colors.surface.tertiary,
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: 10,
          }}
        >
          {icon}
        </View>
        <View style={{ flex: 1 }}>
          <Text style={{ color: colors.text.primary, fontSize: 13, fontWeight: '600' }} numberOfLines={1}>
            {title}
          </Text>
          <Text style={{ color: colors.text.tertiary, fontSize: 11, marginTop: 1 }} numberOfLines={1}>
            {subtitle}
          </Text>
        </View>
        {comingSoon && (
          <View
            style={{
              backgroundColor: colors.surface.tertiary,
              borderRadius: 4,
              paddingHorizontal: 6,
              paddingVertical: 2,
            }}
          >
            <Text
              style={{
                color: colors.text.tertiary,
                fontSize: 9,
                fontWeight: '600',
                textTransform: 'uppercase',
                letterSpacing: 0.5,
              }}
            >
              Soon
            </Text>
          </View>
        )}
      </Pressable>
    </View>
  );
}

export function ScoreCTAEmptyState({
  onUploadDeck,
  onConnectDataRoom,
  onScoringInterview,
}: ScoreCTAEmptyStateProps) {
  const colors = useThemeColors();
  return (
    <View>
      <CTACard
        icon={<Upload size={15} color={colors.info} />}
        title="Upload Pitch Deck"
        subtitle="PDF, PPT · auto-extracted"
        highlightBg={colors.primary[50]}
        onPress={onUploadDeck}
        colors={colors}
      />
      <CTACard
        icon={<Database size={15} color={colors.text.secondary} />}
        title="Connect Data Room"
        subtitle="Google Drive, Notion, Dropbox"
        onPress={onConnectDataRoom}
        colors={colors}
      />
      <CTACard
        icon={<Mic size={15} color={colors.primary[600]} />}
        title="Scoring Interview"
        subtitle="A quick guided conversation"
        highlightBg={colors.primary[50]}
        onPress={onScoringInterview}
        colors={colors}
      />
    </View>
  );
}
